"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGlobeFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2.35C14.62 3.76 11.33 7.84 11 15h10c-.32-7.2-3.61-11.25-5-12.65zM18.58 29.75A14 14 0 0030 17h-7a21.37 21.37 0 01-4.42 12.75zM13.43 2.24A14 14 0 002.05 15H9a21.52 21.52 0 014.43-12.76zM2.05 17a14 14 0 0011.37 12.75A21.36 21.36 0 019 17zM30 15A14 14 0 0018.57 2.24 21.45 21.45 0 0123 15zM16 29.66c1.39-1.37 4.68-5.38 5-12.66H11c.32 7.28 3.61 11.29 5 12.66z" })));
}
exports.default = SvgGlobeFilled;
//# sourceMappingURL=GlobeFilled.js.map